export const state = {
    userMessageArray: {
        error: '',
        success: '',
        message: '',
        redirect: ''
    },
    userArray: [],
    userRoles: []
}